const styles = theme => ({
  actionButton: {
    width: '100%'
  },
  activateButton: {
    padding: theme.spacing.unit,
    position: 'absolute',
    right: 52
  }
});

export default styles;
